import { balanceItems } from '../constants/balance';
import { type Balance } from '../types/userType';

import { isKeyOf } from './isKeyOf';

const transformToBalance = <T extends object>(data: T): Partial<Balance> => {
  const result: Partial<Balance> = {};

  balanceItems.forEach((field) => {
    if (isKeyOf(data, field)) {
      const valueisNumber = typeof data[field] === 'number';

      if (valueisNumber) {
        result[field] = data[field];
      }
    }
  });

  return result;
};

export { transformToBalance };
